import React from "react";
import PropTypes from "prop-types";

import Breadcrumbs from "../../../../components/BreadCrumbs";
import ClientProfileDetailsCard from "../../../../components/Clients/ClientProfileDetailsCard";
import ClientProfileEvents from "../../../../components/Clients/ClientProfileEvents";
import { CLIENT_PROFILE_EMPTY_VALUE } from "../../../../components/Clients/clientProfileHelpers";
import { UIButton, UIPageHeader } from "../../../../components/ui";

import "../../../../components/Clients/clientPortalPages.scss";

const ClientProfileView = ({
  clients,
  breadcrumbList,
  client,
  loading = false,
  canEdit,
  filterByClientId,
  clientId,
  eventsPortal,
  onEditProfile,
}) => {
  if (loading && !client) return null;

  const headerActions = canEdit ? (
    <UIButton
      type="button"
      variant="ghost"
      appearance="outline"
      size="small"
      className="client-portal-profile-page__edit-btn"
      onClick={onEditProfile}
    >
      {clients.editProfile}
    </UIButton>
  ) : null;

  return (
    <div className="client-portal-page client-portal-profile-page">
      <Breadcrumbs list={breadcrumbList} BreadCrumbHasBackIcon={false} />
      <h2 className="page-title">{clients.clientProfile}</h2>

      <UIPageHeader
        className="client-portal-profile-page__header"
        actions={headerActions}
        title={client?.name || CLIENT_PROFILE_EMPTY_VALUE}
      />

      <ClientProfileDetailsCard client={client} labels={clients} />

      {clientId || filterByClientId ? (
        <ClientProfileEvents
          portal={eventsPortal || "company"}
          clientId={clientId}
          filterByClientId={filterByClientId}
        />
      ) : null}
    </div>
  );
};

ClientProfileView.propTypes = {
  clients: PropTypes.object.isRequired,
  breadcrumbList: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string,
      label: PropTypes.string,
    }),
  ).isRequired,
  client: PropTypes.object,
  loading: PropTypes.bool,
  canEdit: PropTypes.bool.isRequired,
  filterByClientId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  clientId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  eventsPortal: PropTypes.oneOf(["admin", "company"]),
  onEditProfile: PropTypes.func.isRequired,
};

ClientProfileView.defaultProps = {
  client: null,
  loading: false,
  filterByClientId: null,
  clientId: null,
  eventsPortal: "company",
};

export default ClientProfileView;
